function AvConfigurationCtrl($scope, $controller, $location,  $timeout, $state, $filter, $element, IconsService, GeneralUtilsService, FieldsService, DiscoveryQueryService) {
	$scope.$root.dividedInner = true;

	// $controller('SecurityCtrl', { $scope: $scope, $location: $location, $timeout: $timeout, $state: $state });
	$controller('PolicyFormCtrl', { $scope: $scope, $controller: $controller, $location: $location, $timeout: $timeout, $state: $state, IconsService: IconsService, GeneralUtilsService: GeneralUtilsService});
	$controller('ConfigController', { $scope: $scope, $timeout: $timeout });

	$scope.malwareEnabled = false;
	$scope.ngMalwareEnabled = false;
	$scope.ipsEnabled = false;
	$scope.configPageOptions = {
		selector: '#avConfiguration',
		openAll: true,
		noHeightCalcs: true,
	};
	$scope.origIpsRules = [];
	DiscoveryQueryService.loadFeedTypeIpSignatures();

	store.fetch({
		path: 'avConfiguration',
		queryParams: { accountId: $state.params.accountId, type: 'account' },
		success: function (data) {
			$timeout(function () {
				$scope.reload(data);
				$scope.mailingLists = [];
				data.mailingDefinition.mails.forEach(function (list) {
					$scope.mailingLists.push(list.name);
				});
				setSafeSearchSettings();
			}, 0);
		},
	});

	var isEnabled = function (account, type) {
		var noPlan = !account.plan;
		var trialPlan = account.plan && account.plan.currentLifeCycle === 'Trial';
		var typeEnabledInPlan = account.plan && (type === 'av' ? account.plan.malwareProtection : (type === 'ng_av' ? account.plan.ngMalwareProtection : account.plan.ips));

		return noPlan || trialPlan || typeEnabledInPlan;
	};
	$scope.reload = function (data) {
		$scope.account = data;
		$scope.malwareEnabled = isEnabled($scope.account, 'av');
		$scope.ngMalwareEnabled = isEnabled($scope.account, 'ng_av');
		$scope.ipsEnabled = isEnabled($scope.account, 'ips');
		$scope.orig = angular.copy($scope.account);
		$scope.origGeoRules = getGeoRules();
		$scope.datamodified = new Date().getTime();
		setSafeSearchSettings();
	};

	function setSafeSearchSettings() {
		let newSafeSearchSettings = {
			id: GeneralUtilsService.getRandomId(),
			name: 'SafeSearchSettings',
			google: false,
			bing: false,
			youtube: {
				enable: false,
				strictMode: false
			}
		};

		$scope.origSafeSearch = $scope.account.safeSearchSettings ? angular.copy($scope.account.safeSearchSettings): angular.copy(newSafeSearchSettings);
		$scope.safeSearch = angular.copy($scope.origSafeSearch);
	}

	function getGeoRules () {
		var items = [];
		if ($scope.account.ipsConfiguration && $scope.account.ipsConfiguration.rules) {
			items = $scope.account.ipsConfiguration.rules.filter(function(item) { return item.ruleType === 'GEO'});

			items.forEach(function (item) {
				if (item.source) {
					item.source.forEach(function(country) {
						country.type = 'Country';
						country.id = country.code;
					});
				}
				item.status = 'saved';
			});
		}

		return items;
	}

    $scope.$watch('account.avConfigurationEnabled', function(newValue, oldValue) {
        if (newValue == oldValue)
            return;
		if(!newValue && $scope.account.ngAvConfigurationEnabled){
			$scope.account.ngAvConfigurationEnabled = false;
		}

    }, true);


	$scope.$root.hasChanges = function () {
		var account = $scope.account;
		if (!account) return false;
		if (!angular.equals($scope.avRulesConfig.items, $scope.origAvRules)) return true;
		if (!angular.equals($scope.account.avConfigurationEnabled, $scope.orig.avConfigurationEnabled)) return true;
		if (!angular.equals($scope.account.ngAvConfigurationEnabled, $scope.orig.ngAvConfigurationEnabled)) return true;
		if (!angular.equals($scope.account.ipsConfigurationEnabled, $scope.orig.ipsConfigurationEnabled)) return true;
		if ($scope.account.ipsConfiguration && $scope.orig.ipsConfiguration &&
			!angular.equals($scope.account.ipsConfiguration.blockNewDomains, $scope.orig.ipsConfiguration.blockNewDomains)) return true;
        if ($scope.account.ipsConfiguration && $scope.orig.ipsConfiguration &&
            !angular.equals($scope.account.ipsConfiguration.suspiciousIPQuarantine, $scope.orig.ipsConfiguration.suspiciousIPQuarantine)) return true;
		if ($scope.ipsRulesConfig && $scope.ipsRulesConfig.items) {
			if (!angular.equals($scope.ipsRulesConfig.items, $scope.origIpsRules)) return true;
		}
		if ($scope.ipsWhitelistConfig && $scope.ipsWhitelistConfig.items) {
			if (!angular.equals($scope.ipsWhitelistConfig.items, $scope.orig.ipsWhitelistRules)) return true;
		}
		if ($scope.antiMalwareConfig && $scope.antiMalwareConfig.items ) {
			if (!angular.equals($scope.antiMalwareConfig.items, $scope.orig.antiMalwareRules)) return true;
		}
		if ($scope.rulesConfig && $scope.rulesConfig.items) {
			if (!angular.equals($scope.rulesConfig.items, $scope.origGeoRules)) return true;
		}
		if (!angular.equals($scope.safeSearch, $scope.origSafeSearch)){
			account.safeSearchSettings = angular.copy($scope.safeSearch);
			return true;
		}

        // if (!angular.equals($scope.account, $scope.orig)) return true;
		return false;
	};

	$scope.actionsConfig = {
		selectedAction: null,
		selectedAMaction: null,
		selectedAMrule: null,
		selectedAMscope: null,
		selectedAMverdict: null,
	};

	let tableHeader = [
		{ 'label': 'Scope', 'path': 'type', noSort: true },
		{ 'label': 'Name', 'path': 'description', noSort: true },
		{ 'label': 'From', 'path': '', noSort: true },
		{ 'label': 'To', 'path': '', noSort: true },
		{ 'label': 'Signature ID', 'path': '', noSort: true },
		{ 'label': 'Protocol/Port', 'path': '', noSort: true },
		{ 'label': 'Track', 'path': '', noSort: true },
		{ 'label': 'Enable', 'path': '', noSort: true },
		{ 'label': '', 'path': '', noSort: true }
	];

	var FieldTypes = FieldsService.getFieldTypes();

	$scope.ipsWhitelistConfig = {

		dataURL: function () {
			return null;
		},
		titleSearch: true,
		alternativeHead: tableHeader,
		searchField: 'description',
		icons: IconsService.getIcons('policy'),
		clientSideSearch: true,
		editTrigger: function (item, id) {
			$scope.$root.$emit('$openPopup', 'triggerSelector', 'trigger_' + id);

			var alertFrequency = item.alertFrequency ? item.alertFrequency : 'HOURLY';
			var addresses = item.addresses ? item.addresses : 'All Admins';

			// in case of quality issues, only the mailing list can be edited by the user
			$scope.scopeSelection = {
				item: item, trigger: item.trigger, alertFrequency: alertFrequency, addresses: addresses, createEvent: item.createEvent, showEventToggle: true
			};
		},
		noDataMessage: ' ',
		specialActions: [
			{
				icon: 'add',
				tooltip: 'Add',
				id: 'add-ips',
				innerActions: [
					{
						icon: 'WAN',
						name: 'WAN',
						func: function() {
							addRule($scope.ipsWhitelistConfig, 'WAN');
							var targetElId = 'inner-action-add-ips';
							$scope.toggleDropDown(targetElId);
						}
					},
					{
						icon: 'Inbound',
						name: 'Inbound',
						func: function() {
							addRule($scope.ipsWhitelistConfig, 'Inbound');
							var targetElId = 'inner-action-add-ips';
							$scope.toggleDropDown(targetElId);
						}
					},
					{
						icon: 'Outbound',
						name: 'Outbound',
						func: function() {
							addRule($scope.ipsWhitelistConfig, 'Outbound');
							var targetElId = 'inner-action-add-ips';
							$scope.toggleDropDown(targetElId);
						}
					},
					{
						icon: 'Any',
						name: 'Any',
						func: function() {
							addRule($scope.ipsWhitelistConfig, 'Any');
							var targetElId = 'inner-action-add-ips';
							$scope.toggleDropDown(targetElId);
						}
					},
				],
				func:  function(selectedItems, tableConfig, $event) {
					var targetElId = 'inner-action-add-ips';
					$scope.toggleDropDown(targetElId, $event);
				},
			},
		],
		rulesFields: {
				portsProtocolsList: {
					name: 'portsProtocolsList',
					id: 'portsProtocolsList',
					types: [
						{
							name: 'Protocol/Port',
							field: FieldTypes.portsProtocols,
						}]
				},
				Inbound: {
					categories: {
						name: 'Category',
						id: 'categories',
						types: [
							{
								name: 'Any',
								field: FieldTypes.all,
							},
							{
								name: 'IP Range',
								field: FieldTypes.adhocIpRange
							},
							{
								name: 'Remote ASN',
								field: FieldTypes.asn
							},
							{
								name: 'Countries',
								field: FieldTypes.countries
							}
						]
					},
					to: {
						name: 'To',
						id: 'to',
						types: [
							{
								name: 'Any',
								field: FieldTypes.all,
							},
							{
								name: 'IP',
								field: FieldTypes.ips,
							},
							{
								name: 'Directory Users',
								field: FieldTypes.dsUser
							},
							{
								name: 'VPN User',
								field: FieldTypes.accesslogins
							},
							{
								name: 'Host',
								field: FieldTypes.subnets
							},
							{
								name: 'Groups',
								field: FieldTypes.groups
							},
							{
								name: 'Sites',
								field: FieldTypes.sites,
							},
							{
								name: 'Floating ranges',
								field: FieldTypes.floatingIps
							},
							{
								name: 'Networks',
								field: FieldTypes.ipRanges,
							}
						]
					}
				},
				Outbound: {
					from: {
						name: 'From',
						id: 'from',
						types: [
							{
								name: 'Any',
								field: FieldTypes.all,
							},
							{
								name: 'IP',
								field: FieldTypes.ips,
							},
							{
								name: 'Directory Users',
								field: FieldTypes.dsUser
							},
							{
								name: 'VPN User',
								field: FieldTypes.accesslogins
							},
							{
								name: 'Groups',
								field: FieldTypes.groups
							},
							{
								name: 'Sites',
								field: FieldTypes.sites,
							},
							{
								name: 'Floating ranges',
								field: FieldTypes.floatingIps
							},
							{
								name: 'Host',
								field: FieldTypes.subnets
							},
							{
								name: 'Networks',
								field: FieldTypes.ipRanges,
							}]
					},
					categories: {
						name: 'Category',
						id: 'categories',
						types: [
							{
								name: 'Any',
								field: FieldTypes.all,
							},
							{
								name: 'IP Range',
								field: FieldTypes.adhocIpRange
							},
							{
								name: 'Remote ASN',
								field: FieldTypes.asn
							},
							{
								name: 'Countries',
								field: FieldTypes.countries
							},
							{
								name: 'FQDN',
								field: FieldTypes.FQDN
							},
							{
								name: 'Domain',
								field: FieldTypes.TLD
							}
						]
					}
				},
				WAN: {
					from: {
						name: 'From',
						id: 'from',
						types: [
						{
							name: 'Any',
							field: FieldTypes.all,
						},
						{
							name: 'IP',
							field: FieldTypes.ips,
						},
						{
							name: 'Directory Users',
							field: FieldTypes.dsUser
						},
						{
							name: 'VPN User',
							field: FieldTypes.accesslogins
						},
						{
							name: 'Groups',
							field: FieldTypes.groups
						},
						{
							name: 'Sites',
							field: FieldTypes.sites,
						},
						{
							name: 'Floating ranges',
							field: FieldTypes.floatingIps
						},
						{
							name: 'Host',
							field: FieldTypes.subnets
						},
						{
							name: 'Networks',
							field: FieldTypes.ipRanges,
						}]
					},
					to: {
						name: 'To',
						id: 'to',
						types: [
						{
							name: 'Any',
							field: FieldTypes.all,
						},
						{
							name: 'IP',
							field: FieldTypes.ips,
						},
						{
							name: 'Directory Users',
							field: FieldTypes.dsUser
						},
						{
							name: 'VPN User',
							field: FieldTypes.accesslogins
						},
						{
							name: 'Groups',
							field: FieldTypes.groups
						},
						{
							name: 'Sites',
							field: FieldTypes.sites,
						},
						{
							name: 'Floating ranges',
							field: FieldTypes.floatingIps
						},
						{
							name: 'Host',
							field: FieldTypes.subnets
						},
						{
							name: 'Networks',
							field: FieldTypes.ipRanges,
						}]
					}
				}},
		fields: [
			{
				label: 'a',
				path: 'item',
				template: '<single-ips-rule item="item" table-config="tableConfig">',
				noSort: true
			},
		],
		extraFieldsToSearch: [{ path: 'description' }],
		defer: true,
		sortList: [{ sortField: 'id', sortDir: 'ASC' }],
		pageSize: 50,
		hideCheckboxes: true,
		noAutoSelect: true,
		nameField: 'description',
		innerLoader: true,
		items: [],
		allowPropagation: true,
		keepPageOnRefresh: true,
		deleteRule: function deleteRule(item, $event) {
			var itemIndexToRemove = $scope.ipsWhitelistConfig.items.indexOf(item);
			$scope.ipsWhitelistConfig.items.splice(itemIndexToRemove, 1);
		},
		isToContainsDomain: function isToContainsDomain(item) {
			return item.categories.some(cat => cat.type === 'TLD' || cat.type === 'FQDN')
		},
		isSignatureIpBased: function isSignatureIpBased(item) {
			return DiscoveryQueryService.feedTypeIpSignatures && DiscoveryQueryService.feedTypeIpSignatures[item.signatureId]
		},
		parseData: function () {
			var items = [];
			if ($scope.account && $scope.account.ipsWhitelistRules) { items = $scope.account.ipsWhitelistRules || []; }

			$scope.orig.ipsWhitelistRules = angular.copy(items);
			return items;
		},
	}

	let AntiMalwareTableHeader = [
		{ 'label': '', 'path': '', noSort: true },
		{ 'label': 'Name', 'path': 'description', noSort: true },
		{ 'label': 'Scope', 'path': 'scope', noSort: true },
		{ 'label': 'From', 'path': '', noSort: true },
		{ 'label': 'What', 'path': '', noSort: true },
		{ 'label': 'Verdict', 'path': '', noSort: true },
		{ 'label': 'Action', 'path': '', noSort: true },
		{ 'label': 'Track', 'path': '', noSort: true },
		{ 'label': 'Enable', 'path': '', noSort: true },
		{ 'label': '', 'path': '', noSort: true }
	];

	$scope.antiMalwareConfig = {

		dataURL: function () {
			return null;
		},
		clientSidePaging: true,
		titleSearch: true,
		alternativeHead: AntiMalwareTableHeader,
		searchField: 'description',
		icons: IconsService.getIcons('policy'),
		clientSideSearch: true,
		editTrigger: function (item, id) {
			$scope.$root.$emit('$openPopup', 'triggerSelector', 'trigger_' + id);

			var alertFrequency = item.alertFrequency ? item.alertFrequency : 'HOURLY';
			var addresses = item.addresses ? item.addresses : 'All Admins';

			// in case of quality issues, only the mailing list can be edited by the user
			$scope.scopeSelection = {
				item: item, trigger: item.trigger, alertFrequency: alertFrequency, addresses: addresses, createEvent: item.createEvent, showEventToggle: true
			};
		},
		noDataMessage: ' ',
		ruleActions: ['ALLOW', 'BLOCK'],
		actionData: {
			ALLOW: {name: 'Allow', icon: 'allow', class: 'action-allow'},
			BLOCK: {name: 'Block', icon: 'block', class: 'action-block'},
		},
		changeAMaction: function (item) {
			$scope.$root.$emit('$openPopup', 'amactions', 'action_' + item.id);
			$scope.actionsConfig.selectedAMaction = item.action;
			$scope.actionsConfig.selectedAMrule = item;
		},
		setAMaction: function(popup){
			$scope.actionsConfig.selectedAMrule.action = $scope.actionsConfig.selectedAction;
			$scope.$root.$emit('$closePopup', popup);
		},
		changeAMscope: function (item) {
			 $scope.$root.$emit('$openPopup', 'amscope', 'scope_' + item.id);
		     $scope.actionsConfig.selectedAMscope = item.scope;
			 $scope.actionsConfig.selectedAMrule = item;
		},
		setAMscope: function(popup){
			$scope.actionsConfig.selectedAMrule.scope = $scope.actionsConfig.selectedAMscope;
			$scope.$root.$emit('$closePopup', popup);
		},
		ruleScope: ['WAN', 'INTERNET','ANY'],
		scopeData: {
			WAN: {name: 'Wan', icon: 'am_WAN', class: 'scope-wan'},
			INTERNET: {name: 'Internet', icon: 'am_internet', class: 'scope-internet'},
			ANY: {name: 'Any', icon: 'am_Any', class: 'scope-any'},
		},
		changeAMverdict: function (item) {
			$scope.$root.$emit('$openPopup', 'amverdict', 'verdict_' + item.id);
			$scope.actionsConfig.selectedAMverdict = item.verdict;
			$scope.actionsConfig.selectedAMrule = item;
		},
		setAMverdict: function(popup){
			$scope.actionsConfig.selectedAMrule.verdict = $scope.actionsConfig.selectedAMverdict;
			$scope.$root.$emit('$closePopup', popup);
		},
		ruleVerdict: ['MALICIOUS', 'SUSPICIOUS', 'ANY'],
		verdictData: {
			MALICIOUS: {name: 'Malicious', icon: 'icon-am_malicious', class: 'am_malicious'},
			SUSPICIOUS: {name: 'Suspicious', icon: 'icon-am_suspected', class: 'am_suspected'},
			ANY: {name: 'Any', icon: 'icon-am_allfiles', class: 'am_allfiles'},
		},
		specialActions: [
			{
				text: 'ADD RULE',
				icon: 'add',
				tooltip: 'Add',
				id: 'add-am',
				innerActions: [
					{
						icon: 'top',
						name: 'Top',
						func: function () {
							addAMRule($scope.antiMalwareConfig, 'ANY',0);
							var targetElId = 'inner-action-add-am';
							$scope.toggleDropDown(targetElId);
						},
					},
					{
						icon: 'bottom',
						name: 'Bottom',
						func: function () {
							addAMRule($scope.antiMalwareConfig, 'ANY');
							var targetElId = 'inner-action-add-am';
							$scope.toggleDropDown(targetElId);
							$timeout(function () {
								const $document = $(document);
								$document.scrollTop($document.height());
							}, 0, false);
						},
					},
				],
				func: function (selectedItems, tableConfig, $event) {
					const targetElId = 'inner-action-add-am';
					$scope.toggleDropDown(targetElId, $event);
				},
			},
		],
		searchPredicate: function(item, valueToSearch) {
			return (item.description.toLowerCase().includes(valueToSearch)) ||
				(Object.values(item.from).some(x => x?.display_name?.toLowerCase().includes(valueToSearch))) ||
				(item.verdict.toLowerCase().includes(valueToSearch)) ||
				(Object.values(item.what).some(x => x?.display_name?.toLowerCase().includes(valueToSearch))) ||
				(item.scope.toLowerCase().includes(valueToSearch)) ||
				(item.action.toLowerCase().includes(valueToSearch));
		},
		rulesFields: {
			what: {
				name: 'what',
				id: 'what',
				types: [
					{
						name: 'Any',
						field: FieldTypes.all,
					},
					{
						name: 'Applications',
						field: FieldTypes.antiMalwareApps,
					},
					{
						name: 'Custom Applications',
						field: FieldTypes.customApplications,
					},{
						name: 'Categories',
						field: FieldTypes.categories,
					},
					{
						name: 'Custom Categories',
						field: FieldTypes.customCategories,
					},
					{
						name: 'Service',
						field: FieldTypes.antiMalwareServices,
					},
					{
						name: 'Custom Service',
						field: FieldTypes.customService,
					},
					{
						name: 'Fully Qualified Domain Name',
						field: FieldTypes.FQDN,
					},
					{
						name: 'Domain Name',
						field: FieldTypes.TLD,
					}
				],
			},
			from: {
				name: 'from',
				id: 'from',
				types: [
					{
						name: 'Any',
						field: FieldTypes.all,
					},
					{
						name: 'Site',
						field: FieldTypes.sites,
					}, {
						name: 'Directory Users',
						field: FieldTypes.dsUser,
					}, {
						name: 'VPN User',
						field: FieldTypes.accesslogins,
					}, {
						name: 'Groups',
						field: FieldTypes.groups,
					}, {
						name: 'Hosts',
						field: FieldTypes.subnets,
					}, {
						name: 'Networks',
						field: FieldTypes.ipRanges,
					}, {
						name: 'Floating Ranges',
						field: FieldTypes.floatingIps,
					}, {
						name: 'IP Address',
						field: FieldTypes.ips,
					}],
				},
			},
		fields: [
			{
				label: 's',
				path: '',
				noSort: true,
				template: `
						<div class="arrows-wrapper">
							<a title="Move Priority Up" role="button" ng-disabled="items.indexOf(item) === 0" ng-click="tableConfig.changePriority('up', item, $event)"><svg class="icon icon-arrow"><use xlink:href="/public/images/icons/main.svg#icon-toggle-up"></use></svg></a>
							<a title="Move Priority Down" role="button" ng-disabled="items.indexOf(item) === items.length - 1" ng-click="tableConfig.changePriority('down', item, $event)"><svg class="icon icon-arrow"><use xlink:href="/public/images/icons/main.svg#icon-toggle-down"></use></svg></a>
						</div>`,
			},
			{
				label: 'a',
				path: 'item',
				template: '<single-am-rule item="item" table-config="tableConfig"></single-am-rule>',
				noSort: true
			},
		],
		changePriority: function (direction, item, $event) {
			const index = this.items.indexOf(item);
			$event.stopPropagation();
			var $thisEl = $($element[0]);
			$thisEl.find('.order-change').removeClass('order-change');
			if ((index === 0 && direction === 'up') || (index === this.items.length - 1 && direction === 'down') || index < 0 ) {
				return;
			}
			const targetPriority = item.priority + (direction === 'up' ? -1 : 1);
			const sourcePriority = item.priority;
			if (index !== 0 && direction === 'up') {
				const targetItem = this.items[index - 1];
				targetItem.priority = sourcePriority;
				this.swapRules(this.items, index, index - 1);
			}
			if (index !== this.items.length - 1 && direction !== 'up') {
				const targetItem = this.items[index + 1];
				targetItem.priority = sourcePriority;
				this.swapRules(this.items, index, index + 1);
			}
			item.priority = targetPriority;
			this.refreshViewItems = new Date().getTime();
			this.indexesChangedOrder.forEach(function (i) {
				$thisEl.find('.row-' + i).first().addClass('order-change');
			});
			this.indexesChangedOrder = [];
		},
		indexesChangedOrder:[],
		swapRules:function (arr, indexA, indexB) {
			let temp = arr[indexA];
			arr[indexA] = arr[indexB];
			arr[indexB] = temp;
			this.indexesChangedOrder.push(indexA);
			this.indexesChangedOrder.push(indexB);
		},
		extraFieldsToSearch: [{ path: 'description' }],
		defer: true,
		sortList: [{ sortField: 'id', sortDir: 'ASC' }],
		pageSize: 50,
		hideCheckboxes: true,
		noAutoSelect: true,
		nameField: 'description',
		innerLoader: true,
		icons: IconsService.getIcons('policy'),
		items: [],
		allowPropagation: true,
		keepPageOnRefresh: true,
		deleteRule: function deleteRule(item, $event) {
		let itemIndexToRemove = $scope.antiMalwareConfig.items.indexOf(item);
		let deletedPriority = item.priority;
		$scope.antiMalwareConfig.items.splice(itemIndexToRemove, 1);
		$scope.antiMalwareConfig.items.forEach(function (item) {
			if (item.priority > deletedPriority) {
				item.priority--;
			}
		})},
		parseData: function parseData() {
			var items = [];

			if ($scope.account && $scope.account.antiMalwareRules) {
				items = $scope.account.antiMalwareRules || [];
			}

			items = items.sort(function (o1, o2) {
				return o1.priority - o2.priority;
			});

			$scope.orig.antiMalwareRules = angular.copy(items);

			return items;
		},
	}
	$scope.avExceptionsConfig = {
		fixedLayout: true,
		dataURL: function () {
			return '/getAvExceptions?accountId=' + $state.params.accountId;
		},
		fields: [
			{ label: 'File Name', path: 'name', template: '<span>{{item.fileName}}</span>' },
			{ label: 'SHA-256', path: 'hash', template: '<span>{{item.hash}}</span>' },
			{ label: 'Comment', path: 'comment', template: '<span>{{item.comment}}</span>' },
			{ label: 'Expiration Date', path: 'creationDate', template: "<div><span ng-if='item.expirationDate > 0'>{{item.expirationDate | date:'yyyy-MM-dd HH:mm'}}</span><span ng-if='item.expirationDate == 0'>Forever</span></div>" },
			{ label: 'Last Modified', path: 'lastModified', template: "<span>{{item.lastModified | date:'yyyy/MMM/dd'}}</span>" },
		],
		icons: $scope.icons,
		selectedItems: [],
		processData: function (items, data) {
			$scope.origAvException = angular.copy(items);
		},
		type: 'avException',
		actions: [],
		noSearch: true,
		specialActions: [{
			'icon':'delete',
			'tooltip':'Delete',
			'func' : function(selectedItems,config) {
				avExceptionsRemoveItems(selectedItems,config);
			},
			}],
	};


	function avExceptionsRemoveItems(selectedItems, config) {
		const len = selectedItems.length;
		if (len === 0) {
			$scope.$root.alert('Please select items to delete');
			return;
		}

		const itemsToDelete = [];
		selectedItems.forEach(function (item) {
			itemsToDelete.push(item.id);
		});

		const itemsMessage = len === 1 ? 'one item' : len + ' items';
		$scope.$root.confirm('Are you sure you want to remove ' + itemsMessage + '?', function () {
			store.remove({
				type: 'AVEXCEPTION',
				items: itemsToDelete,
				success: function (data) {
					itemsToDelete.forEach(function (item) {
						let pos = null;
						for (let i = 0; i < config.items.length; i++) {
							if (config.items[i].id === item) {
								pos = i;
								break;
							}
						}
						if (pos != null) {
							config.items.splice(pos, 1);
						}
					});
					config.selectedItems = [];

					$scope.$root.handleServerResponse(data, '', 'Items removed successfully');

				},
			});
		});
	};


	$scope.saveTrigger = function (trigger) {
		$scope.scopeSelection.item.trigger = $scope.scopeSelection.trigger;
		$scope.scopeSelection.item.createEvent = $scope.scopeSelection.createEvent;

		if ($scope.scopeSelection.trigger || trigger) {
			$scope.scopeSelection.item.alertFrequency = $scope.scopeSelection.alertFrequency;
			$scope.scopeSelection.item.addresses = $scope.scopeSelection.addresses;
		}
		$scope.$root.$emit('$closePopup', 'triggerSelector');
	}

	var getNewDefaultRule = function getNewDefaultRule(itemsCollection, traffic) {

		var lengthByType = itemsCollection.filter(function(item) {
			return item.ipsRuleType === traffic;
		}).length;

		return {
			id: GeneralUtilsService.getRandomId(),
			ipsRuleType: traffic,
			from: [FieldsService.getFieldTypes().all.output()],
			to: [FieldsService.getFieldTypes().all.output()],
			categories: [FieldsService.getFieldTypes().all.output()],
			portsProtocolsList: [],
			description: traffic + ' IPS whitelist' + (lengthByType+1),
			name: traffic + ' IPS whitelist' + (lengthByType+1),
			signatureId: 'Any',
			signatureExists: true,
			enabled: true,
			ruleEnabled: true,
			disableComponents: traffic === 'Any'
		};
	};

	var getNewAntiMalwareDefaultRule = function getNewAntiMalwareDefaultRule(itemsCollection, scope, position) {
		function numOfAMItems() {
			return $scope.account.antiMalwareRules.length;
		}

		return {
			id: GeneralUtilsService.getRandomId(),
			from: [FieldsService.getFieldTypes().all.output()],
			what: [FieldsService.getFieldTypes().all.output()],
			description: 'AM rule' + (numOfAMItems() + 1),
			name: 'AM rule' + (numOfAMItems() + 1),
			action: 'BLOCK',
			verdict: 'MALICIOUS',
			enabled: true,
			ruleEnabled: true,
			scope: scope,
			priority: ((position || position === 0 ? position : numOfAMItems()) + 1),
		};
	};

	function addAMRule(tableConfig, scope, position) {
		if (!tableConfig.items) {
			tableConfig.items = [];
		}

		let newRule = getNewAntiMalwareDefaultRule(tableConfig.items, scope, position);

		if (position === 0) {
			tableConfig.items.forEach((item) => item.priority++);
			tableConfig.items.splice(0, 0, newRule);
		} else {
			tableConfig.items.push(newRule);
		}
	};


	var addRule = function(tableConfig, traffic) {
		if (!tableConfig.items) {
			tableConfig.items = [];
		}

		var newRule = getNewDefaultRule(tableConfig.items, traffic);

		tableConfig.items.push(newRule);
	};

	$scope.avRulesConfig = {
		dataURL: function () {
			return null;
		},
		defer: true,
		pageSize: 5,
		fixedLayout: true,
		fields: [
            { label: 'Protection Scope', path: 'name', template: '<span>{{item.name}}</span>', noSort: true },
            { label: 'Malicious File', path: 'action', template: "<div class='action-wrapper' ng-attr-title='{{tableConfig.actionData[item.action].name}}' title='{{tableConfig.actionData[item.action].name}}'><svg id='action_{{tableConfig.type}}_{{item.name | removeSpecialChars}}' title='{{tableConfig.actionData[item.action].name}}.Click to change' class='url-action-button {{tableConfig.actionData[item.action].class}} icon icon-{{tableConfig.actionData[item.action].icon}}' ng-click='tableConfig.changeAction(item)'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-url-{{tableConfig.actionData[item.action].icon}}'></use></svg></div>", noSort: true },
            { label: 'Tracking', path: 'track', template: "<div id='trigger_{{tableConfig.type + $parent.$index}}' class='inline-block' ng-click='tableConfig.editTrigger(item,tableConfig.type + $parent.$index)'><svg class='icon track icon-track' ng-class='{on: item.trigger}'><use xlink:href='/public/images/icons/main.svg#icon-track'></use></svg></div>", noSort: true },
            { label: '', path: 'enabled', template: "<div class='no-disable'><input id='traffic-enabled-toggle_{{tableConfig.type + $parent.$index}}' type='checkbox' ng-model='item.enabled' chked='item.enabled' chx-toggle/></div>", noSort: true },
		],
		type: 'AvConfiguration',
		changeAction: function (item, suspiciousAction) {
			var itemName = $filter('removeSpecialChars')(item.name);
			$scope.$root.$emit('$openPopup', 'actions', (suspiciousAction ? 'suspicious_':'')+'action_' + this.type + '_' + itemName);
			$scope.actionsConfig.rule = item;
			$scope.actionsConfig.suspiciousAction = suspiciousAction;

		},
		selectedItems: [],
		noSearch: true,
		hideCheckboxes: true,
		actions: false,
		editTrigger: function (item, id) {
			$scope.editTrigger(item, id);
		},
		parseData: function () {
			var items = [];
			if ($scope.account && $scope.account.avConfiguration) { items = $scope.account.avConfiguration.rules || []; }

			if (items.length === 0) {
				items.push({
					name: 'WAN Traffic', action: 'BLOCK', suspiciousAction: 'MONITOR', addresses: '', enabled: true, ruleType: 'AV'
				});
				items.push({
					name: 'Internet Traffic', action: 'BLOCK', suspiciousAction: 'MONITOR', addresses: '', enabled: true, ruleType: 'AV'
				});
				items.forEach(function(rule) { rule.suspiciousAction = rule.suspiciousAction || 'MONITOR';});
			}
			$scope.origAvRules = angular.copy(items);
			return items;
		},
		ruleActions: ['BLOCK', 'MONITOR', 'ALLOW'],
		actionData: {
			BLOCK: { name: 'Block', icon: 'block', class: 'action-block' },
			MONITOR: { name: 'Monitor', icon: 'monitor', class: 'action-monitor' },
			ALLOW: { name: 'Allow', icon: 'allow', class: 'action-allow' }
		},
	};

	var ipsConfigCopy = angular.copy($scope.avRulesConfig);
	ipsConfigCopy.type = 'IpsConfiguration';
	ipsConfigCopy.parseData = function () {
		var items = [];
		if ($scope.account && $scope.account.ipsConfiguration) {
			if ($scope.account.ipsConfiguration.rules) {
				items = $scope.account.ipsConfiguration.rules.filter(function(item) { return item.ruleType === 'IPS'});
			}
		}

		if (items.length === 0) {
			items.push({
				name: 'WAN Traffic', action: 'BLOCK', addresses: '', ruleType: 'IPS', enabled: true
			});
			items.push({
				name: 'Inbound Traffic', action: 'BLOCK', addresses: '', ruleType: 'IPS', enabled: true
			});
			items.push({
				name: 'Outbound Traffic', action: 'BLOCK', addresses: '', ruleType: 'IPS', enabled: true
			});
		}
		$scope.origIpsRules = angular.copy(items);
		return items;
	};

	$scope.ipsRulesConfig = ipsConfigCopy;

	//set specific attributes which are relevant only for AV
	//done only after coping of ips - to avoid removal
    $scope.avRulesConfig.fields.splice(2,0,
    	{ label: 'Suspicious File', path: 'Suspicious_action', template: "<div class='action-wrapper' ng-attr-title='{{tableConfig.actionData[item.suspiciousAction].name}}' title='{{tableConfig.actionData[item.suspiciousAction].name}}'><svg id='suspicious_action_{{tableConfig.type}}_{{item.name | removeSpecialChars}}' title='{{tableConfig.actionData[item.suspiciousAction].name}}.Click to change' class='url-action-button {{tableConfig.actionData[item.suspiciousAction].class}} icon icon-{{tableConfig.actionData[item.suspiciousAction].icon}}' ng-click='tableConfig.changeAction(item,true)'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-url-{{tableConfig.actionData[item.suspiciousAction].icon}}'></use></svg></div>", noSort: true })



	$scope.setAction = function (popup) {
	if ($scope.actionsConfig.suspiciousAction){
		$scope.actionsConfig.rule.suspiciousAction = $scope.actionsConfig.selectedAction;
	}
	else {
		$scope.actionsConfig.rule.action = $scope.actionsConfig.selectedAction;
	}
		$scope.$root.$emit('$closePopup', popup);
	};

//    edit
	$scope.saveChanges = function () {
		$scope.account.newSaveMethod = true;

		if (!$scope.account.avConfiguration) { $scope.account.avConfiguration = {}; }
		$scope.account.avConfiguration.rules = $scope.avRulesConfig.items;
		if (!$scope.account.ipsConfiguration) { $scope.account.ipsConfiguration = {}; }

		if (!$scope.ipsWhitelistConfig) { $scope.ipsWhitelistConfig.items = {}; }
		$scope.account.ipsWhitelistRules = $scope.ipsWhitelistConfig.items;

		if (!$scope.antiMalwareConfig) {
				$scope.antiMalwareConfig.items = {};


			$scope.account.antiMalwareRules = $scope.antiMalwareConfig.items;
		}

		if ($scope.rulesConfig && $scope.rulesConfig.items) {
			var geoRules = $scope.rulesConfig.items || [];
			geoRules.forEach(function(rule) { rule.ruleType = 'GEO'; rule.name = 'Geo Restrict Rule';});
			if (!$scope.ipsRulesConfig.items) {
				$scope.ipsRulesConfig.items = [];
			}
			$scope.account.ipsConfiguration.rules = $scope.ipsRulesConfig.items.concat(geoRules || []);
		}

		$scope.origSafeSearch = angular.copy($scope.safeSearch);

		$scope.loading = true;

		store.save({
			path: '/edit',
			data: $scope.account,
			dataObj: 'json',
			queryParams: { accountId: $state.params.accountId, save: true, fields: getEditFields() },
			success: function (data) {
				$scope.loading = false;
				$scope.$root.handleServerResponse(data, '', 'Threat protection settings saved successfully');
				if (data.status !== 'ERROR') {
					$timeout(function () {
						$scope.reload(data.model);
					}, 0);
				}
			},
		});
	};

	$scope.navToTlsSettings = function () {
		$state.go('app.globalAccountConfiguration', {
			category: 'TLSInspection',
		});
	};

	function getEditFields () {
		let baseEditFields = "['ipsConfiguration', 'geoRules', 'avConfigurationEnabled', 'ngAvConfigurationEnabled', 'ipsConfigurationEnabled', 'safeSearchSettings', 'ipsWhitelistRules', ";
		let extraFields = "'antiMalwareRules'" ;

		return baseEditFields + extraFields + ']'
	}

}
